import push from "./push";

/**
 * Sends a `pageView` event for Google Tag Manager
 * https://developers.google.com/tag-manager/devguide#multipush
 */
export default function pushPageView(pageType: string | null): Promise<void> {
    return push("pageView", {
        "enterprise-id": String(process.env.VUE_APP_CJ_ENTERPRISE_ID),
        "page-type": pageType
    });
}
